<p-dropdown *ngIf="projects; else loadingTemplate"
            [panelStyleClass]="styleClass"
            [disabled]="!projects || readonly"
            [(ngModel)]="selectedProject"
            [options]="projects"
            optionLabel="code"
            [filter]="true"
            [showClear]="true"
            dataKey="code"
            [placeholder]="'DATA_MANAGEMENT.SELECT_PROJECT' | translate"
            [emptyMessage]="'DATA_MANAGEMENT.NO_RESULTS' | translate"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            autoWidth="false"
            class="project-dropdown"
            [styleClass]="styleClass"
            [class.readonly]="readonly"
            (onShow)="appendFilterButton(filterButton, $event)"
            [style]="style">
  <ng-template pTemplate="selectedItem">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: selectedProject }"></ng-container>
  </ng-template>

  <ng-template let-item
               pTemplate="item">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
  </ng-template>
</p-dropdown>

<button #filterButton
        mat-icon-button
        class="myprojects-button"
        [class.active]="filterMyProjects"
        (click)="toggleMyProjectsFilter($event)"
        [title]="'ESTIMATE_PROJECT.MYPROJECTS' | translate">
  <mat-icon class="fad fa-clipboard-user"></mat-icon>
</button>

<ng-template #itemTemplate
             let-projectDto>
  <div *ngIf="projectDto">
    <i *ngIf="projectDto.isImported"
       class="far fa-file-import"></i>
    <i *ngIf="projectDto.hasPCSyncBeenRequested"
       class="far fa-file-export"></i>
    {{ projectDto.project.code }}
    <span *ngIf="projectDto.estimateCodeRef">
      ({{ "DATA_MANAGEMENT.REFERENCE_CODE" | translate }}
      {{ projectDto.estimateCodeRef }})
    </span>
  </div>
</ng-template>


<ng-template #loadingTemplate>
  <!-- PrimeNg dropdown doesnt seem to support setting the selected item before the list (results in clearing the slected item)-->
  <p-dropdown [panelStyleClass]="styleClass"
              [styleClass]="styleClass"
              [disabled]="true"
              [placeholder]="'DATA_MANAGEMENT.SELECT_PROJECT' | translate"
              class="project-dropdown readonly">
  </p-dropdown>
</ng-template>
